import { ExtraReducer } from 'state/store';
import { completeTasksById, getUserTasksByTarget } from './actions';
import { UserTaskState } from './state';
import { LoadingStatus } from 'interfaces/loading-statuses';
import { PayloadAction } from '@reduxjs/toolkit';
import { IUserTaskItem, UserTaskStatus } from './model';

export const reducers = {
    setNewOrUpdatedUserTask: (state: UserTaskState, action: PayloadAction<IUserTaskItem>) => {
        const index = state.userTasks.findIndex((userTask) => userTask.id === action.payload.id);
        if (index !== -1) {
            state.userTasks[index] = action.payload;
        } else {
            state.userTasks.push(action.payload);
        }
    },
    removeCompletedUserTasks: (state: UserTaskState, action: PayloadAction<IUserTaskItem>) => {
        state.userTasks = state.userTasks.filter((userTask) => userTask.id !== action.payload.id);
    },
};

export const extraReducers: ExtraReducer<UserTaskState> = (builder) =>
    builder
        .addCase(completeTasksById.pending, (state) => {
            state.completeTaskLoading = LoadingStatus.Pending;
        })
        .addCase(completeTasksById.fulfilled, (state, { meta }) => {
            state.completeTaskLoading = LoadingStatus.Completed;

            const taskIndex = state.userTasks.findIndex((task) => meta.arg.ids.indexOf(task.id) > -1);
            if (taskIndex > -1) {
                state.userTasks[taskIndex].status = UserTaskStatus.Completed;
            }
        })
        .addCase(completeTasksById.rejected, (state) => {
            state.completeTaskLoading = LoadingStatus.Failed;
        })
        .addCase(getUserTasksByTarget.pending, (state) => {
            state.userTasksLoading = LoadingStatus.Pending;
        })
        .addCase(getUserTasksByTarget.fulfilled, (state, { payload: userTasks }) => {
            state.userTasksLoading = LoadingStatus.Completed;
            state.userTasks = userTasks;
        })
        .addCase(getUserTasksByTarget.rejected, (state) => {
            state.userTasksLoading = LoadingStatus.Failed;
        });
